import HarnessPage from './views/Harness';

export const harnessRoutes = [
  {
    path: 'harness',
    name: '智能助手',
    icon: 'desktop',
    hideInMenu: true,
    element: <HarnessPage />,
  },
];
